import React from 'react';
import RichText from '@synergycms_core/components/generic/RichText';

import { Loading } from '@synergycms_core/components/functional/Loading';


export const LoadingFragment = () => (
  <React.Fragment>
    <Loading
      richText={{
        innerStyle: ['descriptionText'],
        ucFirst: true,
        text: '_%estamos procesando su reserva%_',
        translate: true
      }}
    />
  </React.Fragment>
);

export const LoadingConfirmation = () => (
  <React.Fragment>
    <Loading
      richText={{
        innerStyle: ['descriptionText'],
        ucFirst: true,
        text: '_%estamos confirmando su reserva%_',
        translate: true
      }}
    />
  </React.Fragment>
);

export class EPGContainer extends React.Component {
  static displayName = 'EPGContainer';

  render() {
    const { tpvEnabled, epgCashierContainer, epgPrepayToken, payFormSelected, reservationPaid } = this.props;
    return (
      tpvEnabled === 'EPG' && !reservationPaid && (
        <span>
          <div
            id={epgCashierContainer}
            // Els estils son en linia per aconseguir ser mes restrictius que els del HTML
            style={payFormSelected === 'op' && epgPrepayToken === false ? { display: 'block' } : { display: 'none' }}
          />
        </span>
      )
    );
  }
}
